<template>
  <div class="contentHome">
    <div class="centerPage">
      <div class="search-box">
        <router-link class="title " to="/news">新闻资讯</router-link>
        <router-link class="title" to="/study">每日研究</router-link>
        <span class="title active">亦笙公益</span>
        <router-link class="title" to="/regionalResources">地区资源</router-link>
      </div>
      <div class="flex" style="align-items: normal">
        <div class="left">
          <span class="title">科普文章类型</span>
          <div class="type">
            <p @click="change(0,0)" :class="active==0?'activeClass':''">
              <span>全部</span>
              <img src="../../assets/img/activeImg.png" alt="" width="17" v-show="active==0">
            </p>
            <p v-for="(obj,index) in articleType" :key="obj.id" :class="active==index+1?'activeClass':''"
               @click="change(index+1,obj.id)">
              <span>{{ obj.itemName }}</span>
              <img src="../../assets/img/activeImg.png" alt="" width="17" v-show="active==index+1">
            </p>
          </div>
        </div>
        <div class="right">
          <div v-if="page.total==0" style="text-align: center;color: #DFE0E7">
            <img src="../../assets/img/empty_tips.png" alt="">
            <div>暂无数据</div>
          </div>
          <div v-for="(item,ind) in page.rows" :key="ind" class="popularScience" @click="toDetail(item)">
            <div v-if="item.thumbnailPath" class="objImg img"
                 :style="'backgroundImage: url('+item.thumbnailPath+')'"></div>
            <div class="flex scienceList">
                        <span class="time">
                            <span class="pub-date day">{{ item.publishDate | dateFmt(0) }}</span>
                            <span class="pub-date month">{{ item.publishDate | dateFmt(1) }}</span>
                        </span>
              <div>
                <h3>{{ item.title }}</h3>
                <p class="count">
                  <span>{{ item.doctorName }}</span>
                  <span>{{ item.viewsCount }}人已阅读</span>
                  <span class="belongTo">{{ item|getScienceType(that) }}</span>
                </p>
              </div>
            </div>
            <p class="desc">{{ item.summary }}</p>
          </div>

          <el-pagination
              background
              prev-text="Prev"
              next-text="Next"
              class="pagination"
              :hide-on-single-page="true"
              @current-change="skipPage"
              :current-page="page.current"
              :page-size="page.size"
              layout="prev, pager, next, total"
              :total="page.total">
          </el-pagination>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
import base from '@/api/common';

export default {
  name: "publicWelfare",
  data() {
    return {
      that: this,
      articleType: [],
      articleTypeMap: new Map(),
      active: 0,
      page: {
        type: 0,
        current: 1,
        size: 5,
        total: 16,
        rows: []
      },
    }
  },
  mounted() {
    //1. 加载类型
    this.$ajax.get(base.api.dict.article.science).then((res) => {
      if (res.data.status === 'success') {
        this.articleType = res.data.list;
        $(res.data.list).each((i, o) => {
          this.articleTypeMap.set(o.id, o);
        });
        this.change(0, 0);
      }
    })
  },
  methods: {
    change(index, typeId) {
      this.active = index;
      this.page.current = 1;
      this.page.type = typeId;
      this.getData();
    },
    toDetail(item) {
      this.$router.push({
        name: 'publicWelfareDetail',
        query: {id: item.id, d: item.doctorName, t: item.typeName}
      });
    },
    getData() {
      let that = this;
      this.$ajax.get(base.api.article.science.page.replace("{type}", this.page.type), {
        params: {
          page: this.page.current,
          size: this.page.size
        }
      }).then((res) => {
        if (res.data.status === 'success') {
          this.page.current = res.data.current;
          this.page.size = res.data.size;
          this.page.total = res.data.total;

          $(res.data.rows).each((i, o) => {
            if (!o.thumbnailPath && that.articleTypeMap.get(o.scienceType)) {
              o.thumbnailPath = that.articleTypeMap.get(o.scienceType).itemIcon;
            }
          });

          this.page.rows = res.data.rows;
        }
        this.$nextTick(() => {
          $(".contentIndex").animate({scrollTop: '0px'}, 800);
        });
      });
      //document.querySelector('.homeIndex').scrollTop = 0;//回到顶部
    },
    skipPage(current) {
      this.page.current = current;
      this.getData();
    }
  },
  filters: {
    getScienceType(item, that,) {
      let type = item.scienceType;
      if (type) {
        let scienceType = that.articleTypeMap.get(type);
        if (scienceType) {
          item.typeName = scienceType.itemName;
          return scienceType.itemName;
        }
      }
      return '';
    },
    dateFmt(date, type) {
      let monthEnglish = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Spt", "Oct", "Nov", "Dec"];
      if (date) {
        let d = new Date(date.replace("", "/"));
        if (type === 0) {
          return d.getDate();
        } else if (type === 1) {
          return monthEnglish[d.getMonth()];
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/serviceType.scss";
</style>
